import { IMedia } from '@dtos/Course'
import { IPlaybackStart } from './playbackMemory'

/**
 * URL do player (iframe) do Spark Videos para a mídia.
 *
 * `current_time` e `autoplay` são lidos pelo próprio player
 * (`services/sparkvideos/go/internal/httpapi/player.go`). Sem eles o vídeo
 * sempre abre parado no início.
 */
export function buildSparkVideosPlayerUrl(
  media: Pick<IMedia, 'organizationUuid' | 'hostKey'>,
  { startAt, autoplay }: IPlaybackStart = { startAt: 0, autoplay: false },
): string {
  const base = `${process.env.EXPO_PUBLIC_SPARKVIDEOS_URL}/api/player/${media.organizationUuid}/${media.hostKey}`

  const query = new URLSearchParams()
  const seconds = Math.floor(startAt)
  if (seconds > 0) query.set('current_time', String(seconds))
  if (autoplay) query.set('autoplay', 'true')

  const search = query.toString()
  return search ? `${base}?${search}` : base
}
